import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * .pen "Onboarding 2b—Jurisdiction (Web)": an answered question collapses to a
 * surface row carrying an UPPERCASE muted label and the answer, tappable to
 * re-answer. The stack of these rows is the learner's progress through the step.
 */
export interface AnsweredRowProps {
  label: string;
  value: string;
  onEdit: () => void;
  testId?: string;
}

export const AnsweredRow: React.FC<AnsweredRowProps> = ({ label, value, onEdit, testId }) => (
  <button
    type="button"
    data-testid={testId}
    onClick={onEdit}
    className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl border-2 border-neutral-200 bg-white text-left hover:border-primary-300 transition-colors"
  >
    <span className="min-w-0">
      <span className="block text-xs font-semibold uppercase tracking-wider text-neutral-500">
        {label}
      </span>
      <span className="block truncate text-base font-semibold text-neutral-900">{value}</span>
    </span>
    <ChevronRight className="w-5 h-5 shrink-0 text-neutral-400" />
  </button>
);

export default AnsweredRow;
